import axios from "@/utils/request";
import { snkd } from "@/api/api";
import { getStorage } from "@/utils/storage";
const farmInfo = getStorage("FARMINFO");
// 订单列表
export const orderPageList = (params) => {
  return axios.post(snkd.njDispatch.orderForm.pageList, {
    ...params,
    farmId: farmInfo.farmId,
  });
};
// 取消订单
export const cancelOrder = (params) => {
  return axios.post(snkd.njDispatch.orderForm.cancelOrder, {
    ...params,
    farmId: farmInfo.farmId,
    companyId: farmInfo.companyId,
  });
};
// 订单详情
export const getBaseInfo = (params) => {
  return axios.post(snkd.njDispatch.orderForm.getBaseInfo, {
    ...params,
  });
};
// 订单评价信息
export const getDetailInfo = (params) => {
  return axios.post(snkd.njDispatch.assess.getDetailInfo, {
    ...params,
  });
};
// 订单作业信息
export const getMissionInfo = (params) => {
  return axios.post(snkd.njDispatch.task.getMissionInfo, {
    ...params,
  });
};
// 订单作业订单待评价农机手列表
export const listOrderManipulator = (params) => {
  return axios.post(snkd.njDispatch.njHand.listOrderManipulator, {
    ...params,
  });
};
// 订单作业评价
export const giveScore = (params) => {
  return axios.post(snkd.njDispatch.assess.giveScore, {
    farmId: farmInfo.farmId,
    companyId: farmInfo.companyId,
    ...params,
  });
};
// 农机作业类型
export const getWorkTypeList = (params) => {
  return axios.post(snkd.reslib.njWorkType.listAll, {
    ...params,
    villageId: farmInfo.villageId,
  });
};
// 农机作业类型
export const listCropByWorkType = (params) => {
  return axios.post(snkd.reslib.njWorkType.listCropByWorkType, {
    ...params,
  });
};
// 查询是否配置农忙
export const getConfigService = (params) => {
  return axios.post(snkd.njDispatch.njbusytime.getConfig, {
    ...params,
  });
};
// 意向农机手
export const getNjHandList = (params) => {
  return axios.post(snkd.njDispatch.njHand.pageList, {
    ...params,
  });
};
// 农机大类
export const subjectService = (params) => {
  return axios.post(snkd.njDispatch.machinery.subject, {
    ...params,
  });
};
// 农机小类
export const categoryService = (params) => {
  return axios.post(snkd.njDispatch.machinery.category, {
    ...params,
  });
};
// 申请作业下单
export const getPlaceOrder = (params) => {
  return axios.post(snkd.njDispatch.orderForm.placeOrder, {
    farmId: farmInfo.farmId,
    companyId: farmInfo.companyId,
    ...params,
  });
};
// 农机获取地块列表
export const getnjLandList = (params) => {
  return axios.post(snkd.njDispatch.orderForm.njmap, {
    farmId: farmInfo.farmId,
    companyId: farmInfo.companyId,
    ...params,
  });
};
// 订单地块列表
export const getListOrderLand = (params) => {
  return axios.post(snkd.njDispatch.njland.listOrderLand, {
    ...params,
  });
};
// 农机服务中心
export const getNjServiceCenter = (params) => {
  return axios.post(snkd.njServiceCenter, {
    ...params,
  });
};
// 校验农机服务中心
export const checkServerStation = (params) => {
  return axios.post(snkd.njDispatch.orderForm.checkServerStation, {
    ...params,
  });
};
